import UIHelper from '../../../../helpers/UIHelper';

export const invoicesAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => {
    // const receipts = UIHelper.numberWithDot(i.receipts_sum);
    // // const visitors = UIHelper.numberWithDot(UIHelper.replaceDotToComma(i.visitors_sum));
    // const visitors = UIHelper.numberWithDot(i.visitors_sum);
    return {
      ...i,
      invoices_certificateds: i?.rows || [],
    };
  };

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};
